import { Income } from '@funnels/types';
import { FREQUENCY } from '@funnels/constants';

import { convert } from './conversions';

export default function normaliseIncomesByFrequency(incomes: Income[], frequency: FREQUENCY) {
  return incomes.map((income: Income) => ({
    ...income,
    frequency,
    amount: convert(income.amount!, income.frequency as FREQUENCY, frequency),
  }));
}
